"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAndSubmit = exports.updateFormField = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _constants = require("./constants");
var http = require('lc-http');
var getApplicationStatus = function getApplicationStatus(applicationData) {
  // 1. contractStatus superceeds processState. Only check processState if contractStatus is null
  switch (applicationData.contractStatus) {
    case 'FUNDED':
      return 'Funded';
    case 'DENIED':
      return 'Declined';
    case 'EXPIRED':
      return 'Expired';
    case 'CANCELLED':
      return 'Cancelled';
    case 'READY':
      return applicationData.clientConfirmAmount ? 'Accepted' : 'Approved';
    default:
      return 'Processing';
  }
};
var redirectAfterLoanDecision = function redirectAfterLoanDecision(applicantData, userData, isOfferAccepted) {
  var loantype = 'il';
  if (applicantData.productType === 'IF') {
    loantype = 'ni';
  } else if (applicantData.productType === 'PRP') {
    loantype = 'prp';
  }
  var customFlow = applicantData.customFlow;
  var nextPage;
  var appStatus = getApplicationStatus(applicantData);
  if (appStatus === 'Approved') {
    if (userData.siteAuthorization === 'practice') {
      var dashUrl = '/dashboard?analyticsTrack=%2fdashboard_done&id=' + applicantData.id + '&status=' + appStatus + '&loantype=' + loantype;
      if (customFlow) {
        dashUrl + ('&customFlow=' + customFlow), (0, _readOnlyError2.default)("dashUrl");
      }
      if (applicantData.email && loantype === 'il') {
        nextPage = '/patientsolutions/app/ach-enroll?id=' + applicantData.id;
      } else {
        nextPage = dashUrl;
      }
    } else {
      if ((applicantData.productType === 'IF' || applicantData.productType === 'PRP') && userData.siteAuthorization !== 'admin') {
        nextPage = '/patientsolutions/success?id=' + applicantData.id;
      } else {
        if (userData.siteAuthorization === 'patient') {
          nextPage = '/patientsolutions/app/ach-enroll?id=' + applicantData.id;
        } else {
          nextPage = '/patientsolutions/search?appStatus=' + loantype + appStatus;
        }
      }
    }
  } else if (appStatus === 'Processing' && applicantData.processState === 'SelectPlan') {
    nextPage = '/patientsolutions/app/selectoffer?id=' + applicantData.id + '&clientId=' + applicantData.clientId;
    if (isOfferAccepted) {
      nextPage = nextPage + '&isOfferAccepted=true';
    }
  } else if (appStatus === 'Declined') {
    nextPage = 'selectoffer?id=' + applicantData.id + '&clientId=' + applicantData.clientId;
  } else if (applicantData.processState === 'AdsCreditCheck') {
    nextPage = '/patientsolutions/application_status?status=NI_TECHNICAL&id=' + applicantData.id;
  } else if (applicantData.processState === 'PendingIL' || applicantData.processState === 'AdsInvestigate') {
    if (userData.siteAuthorization === 'practice') {
      nextPage = '/patientsolutions/dashboard?analyticsTrack=%2fdashboard_done';
    } else if (userData.siteAuthorization === 'patient') {
      nextPage = '/patientsolutions/patient_center?analyticsTrack=%2fpatient_center_done';
    } else {
      nextPage = '/';
    }
  } else {
    nextPage = '/patientsolutions/error?id=' + applicantData.id;
  }
  return nextPage;
};
var validateAndSubmit = function validateAndSubmit() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState) {
      var _getState, siteInfo, document, basePath, userInfo, pgAppId, postURL, isAgreementChecked, application, isInterestFree, isPRP, isCheckRequired, postEndPoint, eventPayLoad, postBody, postResponse, redirectURL;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), siteInfo = _getState.siteInfo, document = _getState.document;
            basePath = siteInfo.basePath, userInfo = siteInfo.userInfo;
            pgAppId = document.pgAppId, postURL = document.postURL, isAgreementChecked = document.isAgreementChecked, application = document.application, isInterestFree = document.isInterestFree, isPRP = document.isPRP;
            isCheckRequired = isInterestFree || isPRP;
            postEndPoint = "".concat(basePath).concat(postURL);
            _context.prev = 5;
            eventPayLoad = {
              PF_PROVIDER_CLIENT_ID: pgAppId
            };
            if (!(!isCheckRequired || isCheckRequired && isAgreementChecked)) {
              _context.next = 14;
              break;
            }
            postBody = {
              application: application
            };
            _context.next = 11;
            return http.post(postEndPoint, postBody);
          case 11:
            postResponse = _context.sent;
            redirectURL = redirectAfterLoanDecision(postResponse.data.data, userInfo, true);
            return _context.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: true,
                redirectURL: redirectURL,
                error: false
              }
            }));
          case 14:
            if (!isCheckRequired) {
              _context.next = 18;
              break;
            }
            eventPayLoad[_constants.PF_CA_CHECKBOX_ERROR_EVENT] = true;
            (0, _constants.trackEventWithHeap)(_constants.PF_CA_CHECKBOX_ERROR_EVENT, eventPayLoad);
            return _context.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                error: _constants.CHECK_BOX_ERROR
              }
            }));
          case 18:
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", dispatch({
              type: _constants.VALIDATE_AND_SUBMIT,
              payload: {
                navigationToNextPage: false,
                error: _constants.CHECK_BOX_ERROR
              }
            }));
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 20]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.validateAndSubmit = validateAndSubmit;
var updateFormField = function updateFormField(data) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState) {
      var _getState2, document, isAgreementChecked, newVal;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _getState2 = getState(), document = _getState2.document;
            isAgreementChecked = document.isAgreementChecked;
            newVal = !isAgreementChecked;
            return _context2.abrupt("return", dispatch({
              type: _constants.UPDATE_FORM_FIELD,
              payload: {
                isAgreementChecked: newVal,
                error: !newVal ? _constants.CHECK_BOX_ERROR : false
              }
            }));
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
exports.updateFormField = updateFormField;
